import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXPERIMENT_SETTINGS_PIPELINE_VERSION_UPDATED } from '../../actionTypes/experimentSettings';
var updatePipelineVersion = function updatePipelineVersion(experimentId, pipelineVersion) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: EXPERIMENT_SETTINGS_PIPELINE_VERSION_UPDATED,
              payload: {
                experimentId: experimentId,
                pipelineVersion: pipelineVersion
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updatePipelineVersion;